const ENDPOINTS = {
  registration: "/apps/hcp/customer",
  practice_sample: "/apps/hcp/samples?type=practice",
  patient_sample: "/apps/hcp/samples?type=patient",
};

const STATE_CLASSES = {
  submitting: "form--submitting",
  success: "form--success",
  error: "form--error",
};

const ERROR_SELECTORS = {
  field: ".form__error",
  general: ".form__general-error",
  fieldWrapper: ".form__field",
};

function HCPFormHandler(form) {
  this.form = form;
  this.formId = form.id;
  this.formType = this.detectFormType();
  this.endpoint = ENDPOINTS[this.formType];
  this.isSubmitting = false;

  this.bindEvents();
}

HCPFormHandler.prototype.detectFormType = function () {
  if (this.form.classList.contains("form--registration")) {
    return "registration";
  }
  if (this.form.classList.contains("form--practice_sample")) {
    return "practice_sample";
  }
  if (this.form.classList.contains("form--patient_sample")) {
    return "patient_sample";
  }
  return null;
};

HCPFormHandler.prototype.bindEvents = function () {
  var self = this;
  this.form.addEventListener("submit", function (event) {
    self.handleSubmit(event);
  });

  var otherCredentialSelect = this.form.querySelector('select[name="credentials"]');
  if (otherCredentialSelect) {
    otherCredentialSelect.addEventListener("change", function (event) {
      var otherFieldWrapper = document.getElementById(self.formId + "-credential-other-text-field__row");
      if (otherFieldWrapper) {
        if (event.target.value === "Other") {
          otherFieldWrapper.classList.remove("hidden");
        } else {
          otherFieldWrapper.classList.add("hidden");
        }
      }
    });
  }

  // Bind real-time validation and error clearing
  this.bindFieldValidation();
};

HCPFormHandler.prototype.bindFieldValidation = function () {
  var self = this;

  // Email validation on blur
  var emailInput = this.form.querySelector('input[type="email"]');
  if (emailInput) {
    // Real-time error clearing
    emailInput.addEventListener("input", function () {
      if (emailInput.classList.contains("form__input--error")) {
        self.clearFieldError(emailInput);
      }
    });

    // Validate on blur
    emailInput.addEventListener("blur", function () {
      self.validateEmail(emailInput);
    });
  }

  // Terms checkbox validation
  var termsCheckbox = this.form.querySelector('input[name="terms"]');
  if (termsCheckbox) {
    termsCheckbox.addEventListener("change", function () {
      if (termsCheckbox.checked) {
        self.clearFieldError(termsCheckbox);
      }
    });
  }
};

HCPFormHandler.prototype.validateEmail = function (emailInput) {
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var value = emailInput.value.trim();

  if (!value) {
    this.showFieldError(emailInput, "Email address is required");
    return false;
  }

  if (!emailRegex.test(value)) {
    this.showFieldError(emailInput, "Please enter a valid email address");
    return false;
  }

  return true;
};

HCPFormHandler.prototype.showFieldError = function (input, message) {
  input.classList.add("form__input--error");
  input.setAttribute("aria-invalid", "true");

  var errorId = input.getAttribute("aria-describedby");
  if (errorId) {
    var errorElement = document.getElementById(errorId);
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.classList.remove("form__error--hidden");
    }
  }

  // For checkboxes, add error class to the checkbox container
  if (input.type === "checkbox") {
    var checkboxWrapper = input.closest(".form__checkbox");
    if (checkboxWrapper) {
      checkboxWrapper.classList.add("form__checkbox--error");
    }
  } else {
    var fieldWrapper = input.closest(".form__field");
    if (fieldWrapper) {
      fieldWrapper.classList.add("form__field--error");
    }
  }
};

HCPFormHandler.prototype.clearFieldError = function (input) {
  input.classList.remove("form__input--error");
  input.removeAttribute("aria-invalid");

  var errorId = input.getAttribute("aria-describedby");
  if (errorId) {
    var errorElement = document.getElementById(errorId);
    if (errorElement) {
      errorElement.textContent = "";
      errorElement.classList.add("form__error--hidden");
    }
  }

  // Clear checkbox error state
  if (input.type === "checkbox") {
    var checkboxWrapper = input.closest(".form__checkbox");
    if (checkboxWrapper) {
      checkboxWrapper.classList.remove("form__checkbox--error");
    }
  } else {
    var fieldWrapper = input.closest(".form__field");
    if (fieldWrapper) {
      fieldWrapper.classList.remove("form__field--error");
    }
  }
};

HCPFormHandler.prototype.handleSubmit = function (event) {
  if (this.isSubmitting) return;

  // Always prevent default submission - we'll handle it via fetch
  event.preventDefault();

  this.clearErrors();

  var isValid = true;

  // Explicitly check for product selection on sample forms only
  if (this.formType === 'practice_sample' || this.formType === 'patient_sample') {
    var productSelected = this.form.querySelector('input[name="product"]:checked');
    if (!productSelected) {
      this.displayValidationErrors([
        { field: "product", message: "Please select a product" }
      ]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
  }

  // Validate email
  var emailInput = this.form.querySelector('input[type="email"]');
  if (emailInput && !this.validateEmail(emailInput)) {
    isValid = false;
  }

  // Validate terms checkbox
  var termsCheckbox = this.form.querySelector('input[name="terms"]');
  if (termsCheckbox && !termsCheckbox.checked) {
    this.showFieldError(
      termsCheckbox,
      "You must agree to the terms and conditions",
    );
    isValid = false;
  }

  // Check native form validity
  if (!this.form.checkValidity()) {
    this.form.reportValidity();
    isValid = false;
  }

  if (!isValid) {
    return;
  }

  this.setSubmittingState(true);

  var self = this;
  var formData = new FormData(this.form);

  this.submitForm(formData)
    .then(function (response) {
      self.handleSuccess(response);
    })
    .catch(function (error) {
      self.handleError(error);
    })
    .finally(function () {
      self.setSubmittingState(false);
    });
};

HCPFormHandler.prototype.submitForm = function (formData) {
  var self = this;
  var url = new URL(this.endpoint, window.location.origin);

  if (this.formType === "patient_sample") {
    url.searchParams.set("type", "patient");
  }

  return fetch(url, {
    method: "POST",
    body: formData,
    headers: {
      Accept: "application/json",
    },
  }).then(function (response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        throw { response: response, data: data };
      }
      return data;
    });
  });
};

HCPFormHandler.prototype.handleSuccess = function (data) {
  this.form.style.display = "none";

  var successElement = document.getElementById(this.formId + "-success");
  if (successElement) {
    successElement.style.display = "block";
  }

  this.form.classList.add(STATE_CLASSES.success);
};

HCPFormHandler.prototype.handleError = function (error) {
  window.scrollTo({ top: 0, behavior: "smooth" });

  var response = error.response;
  var data = error.data;

  if (response && response.status === 400) {
    this.displayValidationErrors(data.errors);
  } else if (response && response.status === 422) {
    this.displayValidationErrors(
      data.errors || [{ field: "general", message: data.error }],
    );
  } else if (response && response.status === 500) {
    this.displayGeneralError(data.error || "An unexpected error occurred");
  } else {
    this.displayGeneralError("Network error. Please try again.");
  }
};

HCPFormHandler.prototype.displayValidationErrors = function (errors) {
  var self = this;

  errors.forEach(function (error) {
    var field = error.field;
    var message = error.message;

    if (field === "general") {
      self.displayGeneralError(message);
      return;
    }
    if (field === "accountType") {
      self.displayGeneralError("We're sorry, there was a problem processing your request. Please contact support for assistance.");
      return;
    }

    var errorElement = document.getElementById(
      self.formId + "-" + field + "-error",
    );
    if (errorElement) {
      errorElement.innerHTML = message;
      errorElement.classList.remove("form__error--hidden");
    }

    var fieldWrapper = self.form.querySelector('[name="' + field + '"]');
    if (fieldWrapper) {
      fieldWrapper = fieldWrapper.closest(".form__field");
      if (fieldWrapper) {
        fieldWrapper.classList.add("form__field--error");
      }
    }
  });
};

HCPFormHandler.prototype.displayGeneralError = function (message) {
  var errorContainer = this.form.querySelector(".form__general-error");

  if (!errorContainer) {
    errorContainer = document.createElement("div");
    errorContainer.className = "form__general-error";
    this.form.insertBefore(errorContainer, this.form.firstChild);
  }

  errorContainer.textContent = message;
  errorContainer.style.display = "block";
};

HCPFormHandler.prototype.clearErrors = function () {
  var self = this;

  // Clear all error text elements
  var errorElements = this.form.querySelectorAll(ERROR_SELECTORS.field);
  errorElements.forEach(function (el) {
    el.textContent = "";
    el.classList.add("form__error--hidden");
  });

  // Clear field error states
  var fieldWrappers = this.form.querySelectorAll(ERROR_SELECTORS.fieldWrapper);
  fieldWrappers.forEach(function (el) {
    el.classList.remove("form__field--error");
  });

  // Clear checkbox error states
  var checkboxWrappers = this.form.querySelectorAll(".form__checkbox");
  checkboxWrappers.forEach(function (el) {
    el.classList.remove("form__checkbox--error");
  });

  // Remove error classes from inputs
  var errorInputs = this.form.querySelectorAll(".form__input--error");
  errorInputs.forEach(function (input) {
    input.classList.remove("form__input--error");
    input.removeAttribute("aria-invalid");
  });

  // Clear general error
  var generalError = this.form.querySelector(".form__general-error");
  if (generalError) {
    generalError.style.display = "none";
  }

  this.form.classList.remove(STATE_CLASSES.error);
};

HCPFormHandler.prototype.setSubmittingState = function (isSubmitting) {
  this.isSubmitting = isSubmitting;
  var button = this.form.querySelector('button[type="submit"]');

  if (button) {
    if (isSubmitting) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = "Submitting...";
    } else {
      button.disabled = false;
      button.textContent = button.dataset.originalText || button.textContent;
    }
  }

  if (isSubmitting) {
    this.form.classList.add(STATE_CLASSES.submitting);
  } else {
    this.form.classList.remove(STATE_CLASSES.submitting);
  }
};

document.addEventListener("DOMContentLoaded", function () {
  var forms = document.querySelectorAll(
    ".form--registration, .form--practice_sample, .form--patient_sample",
  );
  forms.forEach(function (form) {
    if (!form.dataset.formHandler) {
      form.dataset.formHandler = "initialized";
      new HCPFormHandler(form);
    }
  });
});
